export default __webpack_public_path__ + "static/media/microsoft.42b61fa1.svg";